/*********************************************************************
* © Copyright IBM Corp. 2024
*********************************************************************/
interface Term {
  name: string
  names: string
  iconSmall: string
  iconBig: string
}

export type GetTermsPerProcess = (
  entityTypeNames: string[]
) => Promise<Record<number, Record<string, Term>>>

export type GetDefaultTerms = (entityTypeNames: string[]) => Promise<Record<string, Term>>

export class TermService {
  constructor(
    private getTermsPerProcess: GetTermsPerProcess,
    private getDefaultTerms: GetDefaultTerms
  ) {}

  // terms may not exist (e.g. may be undefined) in case when ED entity has been disabled
  public async getTerm(entityType: string, processId?: number): Promise<string> {
    if (processId) {
      const mapping = await this.getTermsPerProcess([entityType])

      if (!mapping) {
        return entityType
      }

      // nosemgrep: eslint.detect-object-injection
      return (mapping[processId] && mapping[processId][entityType]?.name) || entityType
    }

    const defaultTerms = await this.getDefaultTerms([entityType])

    if (!defaultTerms) {
      return entityType
    }

    // nosemgrep: eslint.detect-object-injection
    return defaultTerms[entityType]?.name || entityType
  }
}
